import "./app/css/global.css"
import App from "./app/App.svelte"
import WebshopAPI from "./app/api/api"
import { getVisitorId } from "./analytics/integrations/visitor"
const visitorId = getVisitorId()

document.body.innerHTML = ""
const app = new App({
  target: document.body,
  props: {
    WebshopAPI: WebshopAPI(visitorId),
  },
})

export default app
